<template lang="html">
  <div class="vh-100 overflow-y-scroll">
    <div class="flex flex-nowrap pa2">
      <pl-button @click.native="goBack" class="pl-primary"> Go back </pl-button>
      <h1 class="mh4">School/District Management Portal</h1>

      <pl-button
        :class="{ selected: page === 'school' }"
        @click.native="page = 'school'"
        :disabled="page === 'school'"
      >
        School
      </pl-button>
      <pl-button
        :class="{ selected: page === 'district' }"
        @click.native="page = 'district'"
        :disabled="page === 'district'"
      >
        District
      </pl-button>
      <pl-button
        :class="{ selected: page === 'users' }"
        @click.native="goToPageUsers()"
        :disabled="page === 'users'"
      >
        Users
      </pl-button>
    </div>

    <!-- School Management -->
    <div class="container" v-if="page === 'school'">
      <h2>Create New School</h2>
      <div class="">
        <pl-button @click.native="edit_school_modal = true" class="pl-primary">
          Create New School
        </pl-button>
      </div>
      <br />

      <h2>School List</h2>
      <pl-input
        labelText="Search By School Name"
        v-model="school_query"
        @keyup.native="searchBySchoolName"
      />
      <ul>
        <li
          v-for="school in schools"
          @click="goToAdminPortal(school)"
          class="row middle-xs between-xs school-list"
          @mouseenter="hoverSchool(school.id)"
          @mouseleave="hovered = false"
        >
          <span class="school-title pl-title">
            {{ school.name }}
          </span>
          <pl-menu v-if="school.id === hovered" :menuSize="4" direction="right">
            <pl-button slot="menu_trigger" class="pl-icon">
              <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
            </pl-button>
            <ul menu-content>
              <li @click="schoolToDelete(school.id)" style="color: #e53935;">
                Remove School
                <i style="color: #e53935;" class="fas fa-trash-alt" />
              </li>
            </ul>
          </pl-menu>
        </li>
      </ul>
    </div>

    <!-- Teacher Management -->
    <div class="container" v-if="page === 'users'">
      <h2>View Users</h2>

      <pl-input labelText="Search User By Email" v-model="user_query" />
      <pl-button @click.native="searchByUserEmail" class="pl-primary">
        Search
      </pl-button>
      <ul>
        <li
          v-for="user in users"
          @click="selectUser(user)"
          class="pl-title school-in-list"
        >
          {{ user.name }} - {{ user.email }} - {{ user.role }}
        </li>
      </ul>
    </div>

    <!-- District Management -->
    <div class="container" v-if="page === 'district'">
      <h2>Create New District</h2>
      <h3>
        NOTE: Do not create districts here that will be synced through Clever.
        <br />
        The district will show up here after the inital sync.
      </h3>
      <div class="">
        <pl-button :disabled="true" @click.native="" class="pl-primary">
          Create New District
        </pl-button>
        (Disabled for now because I'm assuming districts will only be created by
        clever for now?)
      </div>
      <br />

      <h2>District List</h2>
      <ul>
        <li
          v-for="district in districts"
          @click="selectDistrict(district.id)"
          class="pl-title school-in-list"
        >
          {{ district.name }}
        </li>
      </ul>
    </div>
    <dialog-delete-confirm
      v-if="show_delete_school_modal"
      @close="show_delete_school_modal = false"
      @actionConfirmed="removeSchool"
      :subHeader="contentMessageToRemove"
      optionalText="School"
    />
    <edit-school-modal
      v-if="edit_school_modal"
      @close="edit_school_modal = false"
    />
  </div>
</template>

<script>
  import adminServices from 'services/admin/adminServices';
  import { mapGetters } from 'vuex';
  import dialogDeleteConfirm from 'components/dialogDeleteConfirm';
  import editSchoolModal from 'components/modals/editSchoolModal';
  import { EventBus } from 'utils/event-bus';

  export default {
    data() {
      return {
        districts: [],
        schools: [],
        users: [],
        school_query: '',
        page: 'school',
        user_query: '',
        hovered: false,
        show_delete_school_modal: false,
        school_id_to_delete: null,
        contentMessageToRemove:
          'This will permanently remove this school from Parlay and all associated school data.',
        edit_school_modal: false,
      };
    },
    components: {
      dialogDeleteConfirm,
      editSchoolModal,
    },
    ...mapGetters(['getProfile']),
    mounted() {
      this.getAllSchools();
      this.getAllDistricts();
    },
    methods: {
      goBack() {
        this.$router.push({
          name: 'dashboard',
        });
      },
      getAllDistricts() {
        adminServices
          .getAllDistricts()
          .then((res) => {
            this.districts = res.data;
          })
          .catch(console.log);
      },
      selectDistrict(district_id) {
        this.$router.push(`/admin-view-individual-district/${district_id}`);
      },

      goToAdminPortal(school) {
        this.$router.push({
          name: 'admin-analytics',
          params: { schoolID: school.id },
        });
      },
      selectUser(user) {
        this.$router.push(`/admin-view-individual-user/${user.id}`);
      },
      searchByUserEmail() {
        if (!this.user_query) {
          return;
        }
        adminServices
          .getUsersByEmail(this.user_query)
          .then((res) => {
            this.users = res.data;
            this.user_query = '';
          })
          .catch();
      },
      searchBySchoolName() {
        this.getAllSchools(this.school_query);
      },
      getAllSchools(query = null) {
        adminServices
          .getAllSchools(query)
          .then((res) => {
            this.schools = res.data;
          })
          .catch(console.log);
      },
      goToPageUsers() {
        this.$router.push({
          name: 'admin-portal-parlay-analytics',
        });
      },
      hoverSchool(id) {
        this.hovered = id;
      },
      schoolToDelete(school_id) {
        this.show_delete_school_modal = true;
        this.school_id_to_delete = school_id;
      },
      removeSchool() {
        adminServices
          .deleteSchool(this.school_id_to_delete)
          .then(() => {
            this.school_id_to_delete = null;
            EventBus.$emit('toast-msg', 'School successfully deleted');
            this.getAllSchools();
          })
          .catch((err) => {
            this.school_id_to_delete = null;
            EventBus.$emit('toast-msg', 'Failure, Please try again');
            console.error(err);
          });
      },
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus.styl'

  .selected
    border: 2px solid pl-primary !important

  .school-list
    .school-title
      cursor: pointer
    &&:hover
      color: pl-primary
  button.pl-icon
    margin: 0
    height: 22px
    min-height: 22px
    width: 22px
    min-width: 22px
</style>



// WEBPACK FOOTER //
// schoolManagement.vue?300b3f79